import { useContext } from 'react';

import { ThemeContext, type ThemeContextValue } from './themeContext';

/** Read the active theme and change it. Must be used under a `ThemeProvider`. */
export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext);
  if (value === null) {
    throw new Error('useTheme must be used inside a ThemeProvider');
  }
  return value;
}
